import Certificate, { PaymentRequestResult } from './types'
import axios from 'axios'

export const getCertMoney = (certificate: Certificate) => {
    return new Intl.NumberFormat().format(certificate.amount).replace(',', ' ')
}
export const gotoDeepLink = (certificate: Certificate) => {
    window.open(certificate?.deeplink, '_blank')
    return false
}

export interface PaymentProps {
    nominal: string
    obs_type_id: string
    email: string
    quantity: string
    guid: string
}

export const sendPaymentRequest = async ({
    nominal,
    obs_type_id,
    email,
    quantity,
    guid,
}: PaymentProps): Promise<PaymentRequestResult> => {
    const formData = new FormData()

    formData.append('nominal', nominal)
    formData.append('obs_type_id', obs_type_id)
    formData.append('email', email)
    formData.append('quantity', quantity)
    formData.append('guid', guid)
    const result = await axios({
        method: 'post',
        url: 'https://app.giftyon.com/web_payment.php',
        data: formData,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded"' },
    })
    return result.data
}
export function getNewHref(name: string, value: string) {
    let newHref = ''
    const href = window.location.href
    let regex = new RegExp('[&\\?]' + name + '=')
    if (regex.test(href)) {
        regex = new RegExp('([&\\?])' + name + '=\\d+')
        newHref = href.replace(regex, '$1' + name + '=' + value)
    } else {
        if (href.indexOf('?') > -1) newHref = href + '&' + name + '=' + value
        else newHref = href + '?' + name + '=' + value
    }
    return newHref
}
